module.exports = __webpack_public_path__ + "img/person_on_phone.3b2b788d.svg";